var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"WNFJ2M9SvMAmjuUQ5Zrmp"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

import * as Sentry from "@sentry/nextjs";
import { scrubBreadcrumb, scrubEvent } from "./sentry.scrub";

const SENTRY_DSN = process.env.NEXT_PUBLIC_SENTRY_DSN;

Sentry.init({
	dsn: SENTRY_DSN,
	tracesSampleRate: 1.0,
	environment: process.env.NEXT_PUBLIC_ENV || process.env.NODE_ENV,
	enabled: process.env.NEXT_PUBLIC_ENV === "production",
	beforeSend: scrubEvent,
	beforeSendTransaction: scrubEvent,
	beforeBreadcrumb: scrubBreadcrumb,
});
